@if (timelineService.itemLoading$()) {
  <div class="flex h-screen items-center justify-center">
    <mat-spinner></mat-spinner>
  </div>
} @else if (selectedMessage) {
  <div #topAnchor></div>
  <div class="theme-bg-1 p-2 relative">
    <div class="flex justify-center items-center relative">
      <div class="font-semibold text-center truncate">
        <span class="blue-theme-text-1 truncate">ID:</span>
        {{ selectedMessage.id }}
      </div>
      @if (showHighlightButton) {
        <button
          class="material-icons absolute top-3 right-0 translate-x-full"
          mat-icon-button
          [matTooltip]="'Scroll to highlight'"
          [attr.aria-label]="'extra-action-button'"
          (click)="scrollToFirstHighlight()"
        >
          search
        </button>
      }
    </div>

    <div class="text-center w-full theme-text-1 mt-1">
      <span class="p-1">{{
        selectedMessage?.collectionInfo?.sourceName ?? ''
      }}</span>
      @if (selectedMessage?.collectionInfo?.associatedSources) {
        <span class="truncate text-sm p-1">
          {{ selectedMessage.collectionInfo.associatedSources.join(', ') }}
        </span>
      }
      <span class="p-1">
        {{ selectedMessage?.eventTime | date: 'mediumDate' : 'UTC' }}
      </span>
    </div>
    <div class="flex justify-end">
      <phoenix-translation-switch
        [translationsEnabled]="hasTranslations()"
        [translateLabel]="translateLabel"
      >
      </phoenix-translation-switch>
    </div>
  </div>

  <div class="p-2">
    <div>
      <strong>
        {{ selectedMessage?.eventTime | date: 'yyyy-MM-ddTHH:mm:ss' : 'UTC' }}
      </strong>
    </div>

    <div>
      <div
        [ngStyle]="{
          color: actorsColors
            ? (actorsColors[message?.from?.toLowerCase() ?? ''] ?? '')
            : '',
        }"
      >
        {{ message?.from }}
      </div>

      <div>
        @if (message?.text) {
          <div
            class="px-2 text-sm w-full resize-none overflow-auto cursor-pointer theme-bg-3"
            #highlightContainer
            [innerHTML]="formattedMessageText"
          ></div>
        }

        @if (
          selectedMessage?.attachments &&
          selectedMessage.attachments.length !== 0
        ) {
          <phoenix-message-attachment
            [attachments]="selectedMessage.attachments"
            [heightLimit]="heightLimit"
          ></phoenix-message-attachment>
        }
      </div>

      <br />
      <phoenix-json-record [record]="formattedMessage"></phoenix-json-record>
    </div>
  </div>
}
